import angular from 'angular';

angular.module('cloudX').directive('cxAddressListForm', function() {
  return {
    restrict: 'E',
    template: require('./addressListForm.html'),
    scope: { addresses: '=data', required: '=', country: '=' },
    controller: [
      '$scope',
      'optionsSvc',
      'objectFactorySvc',
      '$timeout',
      'appSettings',
      function($scope, optionsSvc, objectFactorySvc, $timeout, appSettings) {
        $scope.addressList = [];
        $scope.zipcodes = optionsSvc.getOptions('zipCodes');
        if (!$scope.country) $scope.country = appSettings.defaultCountry;

        $scope.zipcodeChanged = function(address, field, $item) {
          if (!$item || !$item.code || !$item.name) return;
          if (field === 0) address.postAddress.city = $item.name;
          if (field === 1) address.postAddress.zipCode = $item.code;
          $timeout(function() {
            $scope.addressChanged(address);
          }, 0);
        };

        $scope.addNewAddress = function() {
          $scope.addressList.push(objectFactorySvc.address());
        };

        $scope.renewNewAddress = function(address) {
          if (address.medium != null) {
            angular.copy(objectFactorySvc.address(address.medium, $scope.country), address);
            address.edit = true;
          }
        };

        var syncAddress = function(address) {
          var idx = $scope.addresses.indexOf(address);
          if (idx < 0) $scope.addresses.push(address);
        };

        var unSyncAddress = function(address) {
          var idx = $scope.addresses.indexOf(address);
          if (idx >= 0) $scope.addresses.splice(idx, 1);
        };

        $scope.addressChanged = function(address) {
          if (!address.$form) return;
          if (
            address.$form.$invalid ||
            (address.medium !== 0 && !address.addressData) ||
            (address.medium === 0 && (!address.postAddress || !address.postAddress.street1))
          ) {
            unSyncAddress(address);
          } else {
            syncAddress(address);
          }
        };

        $scope.remove = function(address) {
          unSyncAddress(address);
          var idx = $scope.addressList.indexOf(address);
          if (idx >= 0) $scope.addressList.splice(idx, 1);
        };

        $scope.sortAddresses = function(address) {
          var mediumSort = address.medium;
          if (address.medium === 0) mediumSort = 9;
          if (address.medium === 3) mediumSort = 5;
          if (address.medium === 4) mediumSort = 3;
          return '' + mediumSort + address.addressData;
        };

        $scope.addressList = angular.copy($scope.addresses);
        $scope.addresses.clear();

        if ($scope.required && !$scope.addressList.length) $scope.addNewAddress();
      },
    ],
  };
});
